import React, { useContext, useState } from 'react';
import { CommunityDragonContext } from '../providers/CommunityDragonProvider';
import { GameDataContext } from '../providers/GameDataProvider';
import Timeline from '../components/Timeline';
import WinrateContributionChart from '../components/WinrateContributionChart';
import WinrateLineChart from '../components/WinrateLineChart';
import Share from '../icons/share_icon.png';
var SummaryPage = function (_a) {
    var gameId = _a.gameId;
    var _b = useContext(CommunityDragonContext), championSummary = _b.championSummary, itemSummary = _b.itemSummary;
    var gameData = useContext(GameDataContext);
    var _c = useState(false), copied = _c[0], setCopied = _c[1];
    var _d = useState(null), popupPosition = _d[0], setPopupPosition = _d[1];
    var handleShareClick = function (e) {
        if (copied) {
            return;
        }
        navigator.clipboard.writeText("https://challengerinsights.gg/game/".concat(gameId));
        var rect = e.currentTarget.getBoundingClientRect();
        setPopupPosition({
            x: rect.left + rect.width / 2 + 65,
            y: rect.top - 3,
        });
        setCopied(true);
        setTimeout(function () {
            setCopied(false);
        }, 1500);
    };
    if (!championSummary || !itemSummary || !gameData) {
        return null;
    }
    return (React.createElement("div", { className: "SummaryPage", style: { color: 'white', textAlign: 'center', height: '100%', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', overflowX: 'hidden' } },
        React.createElement("style", null, "\n                    @keyframes fadeOut {\n                        0% {\n                            opacity: 1;\n                        }\n                        100% {\n                            opacity: 0;\n                        }\n                    }\n                "),
        React.createElement("div", { style: { position: 'relative' } },
            React.createElement("h1", null, "Game Summary"),
            window.electron &&
                React.createElement("img", { src: Share, style: { position: 'absolute', right: -15, top: '50%', height: 30, width: 'auto', cursor: 'pointer', transform: 'translate(100%, -50%)' }, draggable: false, onClick: handleShareClick }),
            copied && popupPosition && (React.createElement("div", { style: {
                    position: 'fixed',
                    left: popupPosition.x,
                    top: popupPosition.y,
                    transform: 'translate(-50%, -50%)',
                    color: 'white',
                    opacity: 1,
                    animation: 'fadeOut 2s forwards',
                    pointerEvents: 'none'
                } }, "Link copied!"))),
        React.createElement("div", { style: { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', width: '95%', paddingTop: 25, paddingBottom: 75 } },
            React.createElement("div", { style: { width: '100%' } },
                React.createElement(Timeline, null)),
            React.createElement("div", { style: { width: '80%', height: 500, marginTop: 75 } },
                React.createElement(WinrateContributionChart, null)),
            React.createElement("div", { style: { width: '100%', height: 500, marginTop: 100 } },
                React.createElement(WinrateLineChart, null)))));
};
export default SummaryPage;
